


import { setGetMailingStatisticsCountWithdrawalsAction } from '../action';
import { getMailingStatisticsCountWithdrawals } from '../api/getMailingStatisticsCountWithdrawals';

export const setGetMailingStatisticsCountWithdrawals = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsCountWithdrawals({
                ...params,
                status: 'ready_for_pay'
            });

            dispatch(setGetMailingStatisticsCountWithdrawalsAction(data));
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}